import { render } from "./PreSentationtwoone.vue?vue&type=template&id=bb22ecea"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/PreSentationtwoone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb22ecea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb22ecea', __exports__)) {
    api.reload('bb22ecea', __exports__)
  }
  
  module.hot.accept("./PreSentationtwoone.vue?vue&type=template&id=bb22ecea", () => {
    api.rerender('bb22ecea', render)
  })

}


export default __exports__